module.exports = __webpack_public_path__ + "img/cv.c0883ced.jpg";